export const SuggestionDialogTestIds = {
  cancelBtnId: 'dialog_cancel_btn',
  confirmBtnId: 'dialog_confirm_btn',
  generateBtnId: 'dialog_generate_btn',
  dialogContentTestId: 'suggestion_dialog_content',
  dialogInputId: 'suggestion_dialog_input',
  dialogActionTestId: 'suggestion_dialog_action'
} as const;
